import {
  BOOKING_STEP,
  BOOKING_ACTION,
  STEP_STATE,
  SERVICE_OPTIONS,
  SERVICE_SELECTION
} from '../constants/AppConstants'
import * as BookingStepsConfig from '../configs/BookingStepsConfig'
import dotProp from 'dot-prop-immutable'

const BOOKING_STEPS_TO_BE_USED = BookingStepsConfig.DEFAULT_BOOKING_STEPS
const STEPS_LENGTH = Object.keys(BOOKING_STEPS_TO_BE_USED).length

const initialState = {
  [BOOKING_STEP.CAR_INFO]: { status: STEP_STATE.PROCESSING, data: {} },
  [BOOKING_STEP.SERVICE_INFO]: {
    status: STEP_STATE.NOT_STARTED,
    data: {
      [SERVICE_OPTIONS.OIL_CHANGE]: {
        displayName: 'Oil Change Service',
        selected: false
      },
      [SERVICE_OPTIONS.BRAKE_SERVICE]: {
        displayName: 'Brake Replacement & Fluid Flush',
        whichBrakes: null,
        padsRotors: null,
        brakeFluidFlush: false,
        selected: false
      },
      [SERVICE_OPTIONS.TIRE_SERVICE]: {
        displayName: 'Tire Replacement',
        whichTires: null,
        tireSize: null,
        selected: false
      },
      [SERVICE_OPTIONS.SCHEDULED_MAINTENANCE]: {
        displayName: 'Manufacturer Recommended Service',
        odometer: null,
        selected: false
      },
      [SERVICE_OPTIONS.EXTERIOR_WASH]: {
        displayName: 'Exterior Hand Wash and Interior Wipe Down',
        selected: false
      },
      [SERVICE_OPTIONS.EXTERIOR_DETAIL]: {
        displayName: 'Exterior Detail',
        selected: false
      },
      [SERVICE_OPTIONS.INTERIOR_DETAIL]: {
        displayName: 'Interior Detail',
        selected: false
      },
      [SERVICE_OPTIONS.ADDITIONAL_NOTES]: null
    }
  },
  [BOOKING_STEP.DATE_LOCATION_INFO]: {
    status: STEP_STATE.NOT_STARTED,
    data: {}
  },
  [BOOKING_STEP.CUSTOMER_INFO]: { status: STEP_STATE.NOT_STARTED, data: {} },
  [BOOKING_STEP.REVIEW_INFO]: { status: STEP_STATE.NOT_STARTED, data: {} },
  currentStepIndex: 0,
  isLoading: false
}

export default function BookingState(state = initialState, { type, payload }) {
  const stepName = payload ? payload.stepName : null
  switch (type) {
    case BOOKING_ACTION.STEP_SUBMIT: {
      const newStepData = {
        ...state[stepName],
        status: STEP_STATE.PROCESSING
      }
      return {
        ...state,
        [stepName]: newStepData
      }
    }
    case BOOKING_ACTION.STEP_ERROR: {
      const newStepData = {
        ...state[stepName],
        status: STEP_STATE.ERRORED_OUT
      }
      return {
        ...state,
        [stepName]: newStepData
      }
    }
    case BOOKING_ACTION.STEP_COMPLETE: {
      const newCurrentStepIndex =
        state.currentStepIndex >= STEPS_LENGTH ? state.currentStepIndex : state.currentStepIndex + 1
      const newStepData = {
        ...state[stepName],
        status: STEP_STATE.FINISHED,
        data: payload.data
      }
      const nextStepName = BOOKING_STEPS_TO_BE_USED[newCurrentStepIndex]
      const nextStepData = {
        ...state[nextStepName],
        status: STEP_STATE.PROCESSING
      }

      return {
        ...state,
        [stepName]: newStepData,
        [nextStepName]: nextStepData,
        currentStepIndex: newCurrentStepIndex
      }
    }
    case BOOKING_ACTION.JUMP_TO_STEP: {
      const stateOfTargetBookingStep = state[stepName].status
      //cannot navigate to step that is in NOT_STARTED state
      if (stateOfTargetBookingStep === STEP_STATE.NOT_STARTED) {
        return state
      }
      const newCurrentStepIndex = BOOKING_STEPS_TO_BE_USED.indexOf(stepName)
      return { ...state, currentStepIndex: newCurrentStepIndex }
    }

    case SERVICE_SELECTION.TOGGLE_SERVICE_SELECTION: {
      const serviceName = payload.serviceName
      const isSelected = state.SERVICE_INFO.data[serviceName].selected
      const newState = dotProp.set(state, `SERVICE_INFO.data.${serviceName}.selected`, !isSelected)
      return newState
    }

    case SERVICE_SELECTION.SET_SERVICE_DATA: {
      const serviceName = payload.serviceName
      payload.data.selected = true
      const newState = dotProp.set(state, `SERVICE_INFO.data.${serviceName}`, payload.data)
      return newState
    }

    case SERVICE_SELECTION.SET_ADDITIONAL_NOTES: {
      const serviceName = payload.serviceName
      const newState = dotProp.set(state, `SERVICE_INFO.data.${serviceName}`, payload.data)
      return newState
    }

    case BOOKING_ACTION.RESET:
      return { ...initialState }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/BookingReducer.js